import Image from 'next/image';
import { cn } from '@/lib/utils/utils';

type ZangiaPlusLockIconProps = {
  variant?: 'badge' | 'plain';
  imageClassName?: string;
};

export function ZangiaPlusLockIcon({
  variant = 'plain',
  imageClassName,
}: ZangiaPlusLockIconProps) {
  const image = (
    <Image
      src="/images/zangiaplus/lock.png"
      alt=""
      width={48}
      height={48}
      className={cn(
        'h-12 w-12 object-contain',
        variant === 'badge' && '-ml-2',
        variant === 'plain' && 'shrink-0',
        imageClassName
      )}
    />
  );

  if (variant === 'badge') {
    return (
      <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full border border-primary-100 bg-primary-50">
        {image}
      </div>
    );
  }

  return image;
}
